import { PlanScheduleDay } from "./plan-scheduled-day";
import { DateTime } from "luxon";

export interface AttachSchedulerRequest {
    planId: string;
    planWeekDays: number[];
    fromDate: DateTime;
    toDate ? : DateTime | undefined;
    bufferHours:number;
    executionTime: string;
    timeZoneOffset: string;
}

